
export default function DataTable(theme: any) {


  return {
    // mui-datatables
    MUIDataTable: {
      styleOverrides: {
        root: {
          boxShadow: `rgba(0, 0, 0, 0.35) 0px 5px 15px`,

        }
      }
    },
    MUIDataTableToolbar: {
      styleOverrides: {
        actions: {
          flexDirection: 'row-reverse',
          display: 'flex'
        }
      }
    },

    // mui tables
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#116FFF',
        },
      },
    },
    MUIDataTableSelectCell: {
      styleOverrides: {
        headerCell: {
          backgroundColor: 'blue',
        },
      },
    },
    MuiTableFooter: {
      styleOverrides: {
        root: {
          '& .MuiToolbar-root': {
            backgroundColor: 'white',
          },
        },
      },
    },
  };
}